import type { SavedView } from "../types/SavedView";

/**
 * Generates a fresh view id. Uses `crypto.randomUUID` where available;
 * falls back to a Math.random-backed UUID for environments without it
 * (jsdom on older Node, mostly).
 */
export function generateViewId(): string {
	if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
		return crypto.randomUUID();
	}
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

/** Find a SavedView by id, or null if not found. */
export function findViewById(views: SavedView[], id: string): SavedView | null {
	return views.find((view) => view.id === id) ?? null;
}
